import { Link } from "react-router-dom";
import { Eyebrow, Kinetic, Reveal } from "./anim";

export function PageHero({ eyebrow, lines, sub, children, className = "" }) {
  return (
    <header className={`relative overflow-hidden bg-paper pb-16 pt-36 sm:pb-20 sm:pt-44 ${className}`}>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-blush/50 blur-3xl"
      />
      <div className="relative mx-auto max-w-[1440px] px-6 lg:px-10">
        <Reveal delay={0.1}>
          <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
        <Kinetic
          lines={lines}
          className="mt-7 font-serif text-[13vw] font-light uppercase leading-[0.98] text-ink sm:text-6xl lg:text-7xl xl:text-8xl"
          delay={0.15}
        />
        {sub && (
          <Reveal delay={0.55}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-clay sm:text-lg">{sub}</p>
          </Reveal>
        )}
        {children}
      </div>
    </header>
  );
}

export function CTABand({ title = "Take your brand offline.", sub, cta = "Book Your Space", to = "/book", testid = "cta-band-button" }) {
  return (
    <section className="relative overflow-hidden bg-ink py-24 text-paper sm:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-blushdeep/15 blur-3xl"
      />
      <div className="relative mx-auto max-w-[1440px] px-6 text-center lg:px-10">
        <Kinetic
          inView
          lines={[title]}
          className="mx-auto max-w-4xl font-serif text-4xl uppercase leading-[1.02] sm:text-6xl lg:text-7xl"
        />
        {sub && (
          <Reveal delay={0.3}>
            <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-paper/60 sm:text-base">{sub}</p>
          </Reveal>
        )}
        <Reveal delay={0.45}>
          <Link to={to} data-testid={testid} className="btn btn-blush mt-10">
            {cta}
          </Link>
        </Reveal>
      </div>
    </section>
  );
}

export function SectionHead({ eyebrow, title, sub, light = false, className = "" }) {
  return (
    <div className={className}>
      <Reveal>
        <Eyebrow light={light}>{eyebrow}</Eyebrow>
      </Reveal>
      <Kinetic
        inView
        lines={[title]}
        as="h2"
        className={`mt-5 font-serif text-4xl uppercase leading-[1.02] sm:text-5xl lg:text-6xl ${
          light ? "text-paper" : "text-ink"
        }`}
      />
      {sub && (
        <Reveal delay={0.25}>
          <p className={`mt-6 max-w-2xl text-base leading-relaxed sm:text-lg ${light ? "text-paper/70" : "text-clay"}`}>
            {sub}
          </p>
        </Reveal>
      )}
    </div>
  );
}
